var speed = 600;

$(function() {

    $(".buttonMenu").click(function(){

        var id = $(this).attr("data-id");
        $(".dropDown:not([data-id='" + id + "'])").slideUp(speed);

        if ($(this).hasClass('slick-current')) {
            $(".dropDown[data-id='" + id + "']").addClass('first');
        }
        $(".dropDown[data-id='" + id + "']").slideToggle(speed, function() {
            if (!$(this).is(':visible')) {
                $(this).removeClass('first');
            }
        });

        $("#searchView").stop().slideUp(speed);

        return false;
    });

    $('#carouselMenus').slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: false

    });

    $('#arrow').click(function() {
        $(".dropDown").stop().slideUp(speed);
        $('#carouselMenus .slick-next').click();
    });

});